import { render } from "./SupplierDialog.vue?vue&type=template&id=6b7e4834&scoped=true"
import script from "./SupplierDialog.vue?vue&type=script&lang=ts"
export * from "./SupplierDialog.vue?vue&type=script&lang=ts"

import "./SupplierDialog.vue?vue&type=style&index=0&id=6b7e4834&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b7e4834"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
